import { render, staticRenderFns } from "./SGInstanceProfileSummary.vue?vue&type=template&id=a851c9d2"
import script from "./SGInstanceProfileSummary.vue?vue&type=script&lang=js"
export * from "./SGInstanceProfileSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports